import Axios from 'axios'

export default {
    state: {
        kines: [],
        kine: null
    },
    getters: {
        kines(state) {
            return state.kines
        },
        getKineById: (state) => {
            return state.kine
        }
    },
    mutations: {
        setKines(state, payload) {
            state.kines = payload;
        },
        setKine(state, payload) {
            state.kine = payload;
        },
        clearKine(state) {
            state.kine = null
        }
    },
    actions: {
        getKines: async ({ commit }) => {
            commit('setLoading')
            await Axios.get(process.env.VUE_APP_API_URL_KINES)
                .then(res => {
                    if (res.request.status != 200)
                        res.data = []
                    commit('setKines', res.data)
                    commit('setLoading')
                }
                ).catch(error => {
                    commit('setLoading')
                    commit('clearError')
                    commit('setError', error)
                })
        },
        async loadKineById({ commit }, payload) {
            commit('clearKine')
            commit('setLoading')
            await Axios.get(process.env.VUE_APP_API_URL_KINES_BY_ID + payload)
                .then(res => {
                    commit('setKine', res.data.data)
                    commit('setLoading')
                }
                ).catch(error => {
                    commit('setLoading')
                    commit('clearError')
                    commit('setError', error)
                })
        },
        async updateKine({ commit, getters }, payload) {
            commit('setLoading')
            await Axios.put(process.env.VUE_APP_API_URL_KINES + getters.user.kine._id,
                payload)
                .then(res => {
                    commit('setLoading')
                    // commit('setMessageSuccess', "Votre diplome a été enregisté avec succées");
                }
                ).catch(error => {
                    commit('setLoading')
                    commit('clearError')
                    commit('setError', error)
                })
        }
    }
}
